var _stop, _stop2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgSummaryIcon(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 36V8.2a3 3 0 013-3h3.544c.266-.755.973-1.3 1.81-1.3h1.928c0-2.15 1.73-3.9 3.855-3.9 2.126 0 3.856 1.75 3.856 3.9h1.928c.837 0 1.544.545 1.81 1.3h3.544a3 3 0 013 3V36a3 3 0 01-3 3H3a3 3 0 01-3-3zM14.137 1.3c-1.417 0-2.57 1.166-2.57 2.6h5.141c0-1.434-1.153-2.6-2.57-2.6zm6.427 7.15v-2.6a.647.647 0 00-.643-.65H8.354a.647.647 0 00-.643.65V9.1h12.853v-.65zm.642 1.95H7.07a.646.646 0 01-.643-.65V9.1h-1.57a1 1 0 00-1 1v24a1 1 0 001 1H23.42a1 1 0 001-1v-24a1 1 0 00-1-1h-1.57v.65c0 .36-.288.65-.643.65zm3.784-3.9h-3.141v1.3h1.856a2 2 0 012 2v24.6a2 2 0 01-2 2H4.57a2 2 0 01-2-2V9.8a2 2 0 012-2h1.856V6.5h-3.14a2 2 0 00-2 2v27.2a2 2 0 002 2H24.99a2 2 0 002-2V8.5a2 2 0 00-2-2zM12.744 28.31a.641.641 0 01-.496.289l-.038.001a.64.64 0 01-.488-.227l-3.856-4.55a.654.654 0 01.07-.916.635.635 0 01.906.07l3.303 3.899 7.241-10.987a.639.639 0 01.892-.18c.295.2.374.603.178.902l-7.712 11.7zm1.85-26.171a.675.675 0 01.186.461c0 .169-.07.338-.186.462a.672.672 0 01-.457.188.672.672 0 01-.456-.188.688.688 0 01-.186-.462c0-.175.07-.338.186-.462a.667.667 0 01.913 0z",
    transform: "translate(5.85)",
    fill: "url(#".concat(_id, ")"),
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.175%",
    y1: "7.565%",
    x2: "35.598%",
    y2: "87.141%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE6700",
    offset: "100%"
  })))));
}
export default SvgSummaryIcon;